module.exports = __webpack_public_path__ + "fasaw7.png?60392b0e7de5256ba9a4994f2096b7f0";